import React from 'react';

const Header = () => {
  return (
    <header className="header-area header-sticky">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">
              <a href="/" className="logo">VVIP <em> Coffeebar</em></a>
              <ul className="nav">
                <li><a href="/" className="active">Home</a></li>
                <li><a href="/bookings">Book us Today</a></li>
                <li><a href="/menu">Our Menu</a></li>
                <li className="dropdown">
                  <a className="dropdown-toggle" data-toggle="dropdown" href="/aboutus" role="button" aria-haspopup="true" aria-expanded="false">About</a>

                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="/aboutus">About Us</a>
                    {/* <a className="dropdown-item" href="/blog">Blog</a> */}
                    {/* <a className="dropdown-item" href="/testimonials">Testimonials</a> */}
                  </div>
                </li>
                <li><a href="/contactus">Contact</a></li>
              </ul>
              <a className='menu-trigger' href="void()">
                <span>Menu</span>
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
};

export default Header;
